import './ajx-blog-lib'
import './search'
import './thrive-blogs'
import './thrive-design-ajax-call'
import {handleBgImage} from './thrive-design-background-images'
import './thrive-design-bio-modals'
import './thrive-design-community-home'
import './thrive-design-cta-tiles'
import './thrive-design-footer'
import './thrive-design-general'
import './thrive-design-link-wrapping'
import './thrive-design-sponsors'
import './thrive-design-stylesheet-new.css'
import './thrive-milestone'
import './thrive-smooth-scrolling'
import './accordion'
import './thrive-conference-nav'
import './thrive-conference-schedule'
import './copyright'
import './lightbox-init'
import './countdown-end-date'
import './animated-stat'
import './testimonial-slider'

$(function () {
    $('.bg-image').each(function () {
        handleBgImage($(this), $(this));
    });
});